import { MDBAutocomplete, MDBBtn, MDBCol, MDBRow, MDBScrollspy, MDBScrollspyLink, MDBSelect, MDBSpinner, MDBTable, MDBTableBody, MDBTableHead, MDBTabs, MDBTabsContent, MDBTabsItem, MDBTabsLink, MDBTabsPane } from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { getCompanyDetailInfo, getMisc, LocAddressSeach, updateCompanyInfo } from "../../apiclients/streamsapi_bridge";
import Body from "../../components/body/BodyPage";
import TopMessage from "../../components/header/TopMessage";
import TopSuccess from "../../components/header/TopSuccess";
import MainLinks from "../../components/navlinks/MainLinks";
import SaveChanges from "../../components/topviews/saveCancel";
import { useAdminContext } from "../../components/adminstore/Admin-Context";
import {  validatePhoneNumber } from "../popups/phonenumbers/AddRemoveNumbers";
import TabIDConstant from "../../apiclients/TabIDConstant";
import { CANADA, USA } from "../../components/images";
function AccountInfoLanding() {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const [accountInfo, setAccountInfo] = useState('tab1');
    const [allowRequst, setallowRequst] = useState(true);
    const [isloading, setIsloading] = useState(false);
    const [states, setstates] = useState([]);
    const [timezone, settimezone] = useState([]);
    const [industrytypes, setindustrytypes] = useState([]);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [isDisplay, setisDisplay] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [stateList, setStateList] = useState([]);
    const [typingTimeout, setTypingTimeout] = useState(null);
    const [addressReasults, setAddressReasults] = useState([]);
    const { setEdited, setCompanyName } = useAdminContext();

    const allowAPI = useRef(true);
    const { register, handleSubmit, formState: { isDirty, dirtyFields, errors }, setError, clearErrors, reset, setValue, getValues, watch, control } = useForm({
        defaultValues: {
            global_settings: {
                company_info: {
                    company_name: "",
                    city: "",
                    email: "",
                    zip_code: 0,
                    phone_number: "",
                    admin_last_name: "",
                    admin_first_name: "",
                    user_extension_length: 0,
                    street_address1: "",
                    street_address2: "",
                    state: "",
                    password: "",
                    time_zone: 0,
                    industry_type: ""
                }
            }
        }
    });

    useEffect(() => {
        if (successMessage) {
            setTimeout(() => {
                setSuccessMessage(""); // Clear the success message in the parent component
            }, 5000);
        }
    }, [successMessage]);

    useEffect(() => {
        // Cleanup function to clear timeout when component unmounts or input value changes
        return () => {
            if (typingTimeout) {
                clearTimeout(typingTimeout);
            }
        };
    }, [typingTimeout]);

    const handleBasicClick = (value) => {
        if (value === accountInfo) {
            return;
        }

        setAccountInfo(value);
    }

    useEffect(() => {
        if (allowRequst) {
            getCompanyInfo();
            setallowRequst(false);
        }

    }, [allowRequst]);



    async function getCompanyInfo() {
        try {
            setIsloading(true);
            const response = await getCompanyDetailInfo(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                TabIDConstant.ACC_INFO_SETTINGS_SUBLINK
            );
            setTimeout(() => {
                setIsloading(false);
            }, 1000);
            if (!response) {
                return;
            }
            const companyInfo = await response.json();
            console.log("getCompanyInfo Details ::: " + JSON.stringify(companyInfo));
            const sessionData = sessionStorage.getItem("admin_session") ? JSON.parse(sessionStorage.getItem("admin_session")) : {};
            sessionData.companyName = companyInfo?.global_settings?.company_info?.company_name ?? sessionData.companyName;
             const isAccount = sessionData?.isAccountAdmin ?? false;
            if (isAccount) {
                sessionData.company_name = companyInfo?.global_settings?.company_info?.company_name ?? sessionData.companyName;
            }
            sessionStorage.setItem("admin_session", JSON.stringify(sessionData));
            reset({
                global_settings: {
                    company_info: {
                        company_name: companyInfo?.global_settings?.company_info?.company_name ?? "",
                        city: companyInfo?.global_settings?.company_info?.city ?? "",
                        email: companyInfo?.global_settings?.company_info?.email ?? "",
                        zip_code: companyInfo?.global_settings?.company_info?.zip_code ?? 0,
                        phone_number: companyInfo?.global_settings?.company_info?.phone_number ?? "",
                        admin_last_name: companyInfo?.global_settings?.company_info?.admin_last_name ?? "",
                        admin_first_name: companyInfo?.global_settings?.company_info?.admin_first_name ?? "",
                        user_extension_length: companyInfo?.global_settings?.company_info?.user_extension_length ?? 0,
                        street_address1: companyInfo?.global_settings?.company_info?.street_address1 ?? "",
                        street_address2: companyInfo?.global_settings?.company_info?.street_address2 ?? "",
                        state: companyInfo?.global_settings?.company_info?.state ?? "",
                        password: companyInfo?.global_settings?.company_info?.password ?? "",
                        time_zone: companyInfo?.global_settings?.company_info?.time_zone ?? 0,
                        industry_type: companyInfo?.global_settings?.company_info?.industry_type ?? "",

                    }
                }

            });
            getCompanyInfoMisc();

        } catch (error) {
            console.log(`Error in getCompanyInfo ::::: ${error}`);
        }
    }

    function handleSearchAddressChange(searchValue) {
        try {
            clearErrors("global_settings.company_info.street_address1");
            setValue("global_settings.company_info.street_address1", searchValue, { shouldDirty: true });
            if (typingTimeout) {
                clearTimeout(typingTimeout);
            }
            const newTimeout = setTimeout(() => {
                sendApIRequest(searchValue);
            }, 500);
            // Update the typingTimeout state with the new timeout
            setTypingTimeout(newTimeout);


        } catch (error) {
            console.log(`Error in handleSearchAddressChange :::: ${error}`);

        }
    }

    function handleAddressSelect(address) {
        if (address.street_line) {
            // setaddressValue(address.street_line);
            setValue("global_settings.company_info.street_address1", address.street_line, { shouldDirty: true });
        }
        if (address.secondary) {
            setValue("global_settings.company_info.street_address2", address.secondary, { shouldDirty: true });
        } else {
            setValue("global_settings.company_info.street_address2", "", { shouldDirty: true });

        }
        if (address.city) {
            setValue("global_settings.company_info.city", address.city, { shouldDirty: true });
        }
        if (address.state) {
            const stateObj = states.find(state => state.statecode.trim() === address.state.trim());
            console.log("stateObj :::::::: " + JSON.stringify(stateObj));
            if (stateObj) {
                setValue("global_settings.company_info.state", stateObj.statename, { shouldDirty: true });
            }
        }
        if (address.zipcode) {
            setValue("global_settings.company_info.zip_code", address.zipcode, { shouldDirty: true });
        }


    }
    const sendApIRequest = async (searchValue) => {
        try {
            if (searchValue.trim() !== "" && allowAPI.current) {
                //if (searchValue.trim() !== "") {
                let update = {
                    reqid: 84,
                    search: searchValue,
                    siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                }
                setIsLoading(true);
                console.log("Request for the search :::::: " + JSON.stringify(update));
                const serverResponse = await LocAddressSeach(update);
                setIsLoading(false);
                if (!serverResponse.ok) {
                    console.log("Network response was not ok");
                    throw new Error('Network response was not ok');
                }
                else {
                    const responseData = await serverResponse.json();
                    console.log("Response Data:", JSON.stringify(responseData));
                    let addressList = responseData?.message?.suggestions ?? [];
                    setAddressReasults(addressList);
                    if (addressList.length === 0) {
                        setisDisplay(false);
                    } else {
                        setisDisplay(true);
                    }
                }

            } else {
                allowAPI.current = true;
                setisDisplay(false);
            }



        } catch (error) {
            console.log(`Error in sendApIRequest for address search :::: ${error}`);

        }

    }

    async function getCompanyInfoMisc() {
        console.log(sessionStorage.getItem("admin_session"));
        const response = await getMisc(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            {
                misc: ["global_company_info"],
            }
        );
        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        }
        const tdata = await response.json();
        if (!tdata) {
            window.alert(`info with id  not found`);
            navigate("/");
        }

        console.log("getCompanyInfoMisc for ::::::::::::: " + JSON.stringify(tdata));
        setstates(tdata?.misc?.global_company_info?.state ?? []);
        let timezoneOptions = tdata?.misc?.global_company_info?.timezones ?? [];
        settimezone(
            timezoneOptions.map((item) => {
                const [location, offset] = item.time_zone.split("  ");
                return {
                    text: location,
                    secondaryText: offset,
                    value: parseInt(item.tid),
                };
            })
        );
        setindustrytypes(tdata?.misc?.global_company_info?.industrytypes ?? []);


    }
    function closeSave(e) {
        reset();
    }

    const isSave =
        Object.keys(dirtyFields).length === 0 ? false : true;

    useEffect(() => {
        setEdited(isSave);

    }, [isSave])

    const onSubmit = async (data) => {
        const modifiedData = {};
        const fieldKeys = dirtyFields.global_settings.company_info;
        const fieldData = data.global_settings.company_info;

        Object.entries(fieldKeys).forEach(([key, value]) => {
            modifiedData[key] = fieldData[key];
        });
        let update = {};

        if (modifiedData) {
            if (modifiedData.company_name?.length > 0) {
                modifiedData.company_name = modifiedData.company_name.trim()
            }
            update = {
                reqid: 64,
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                global_settings: {
                    company_info: modifiedData,
                },
            }
            console.log("modified data for company info :::" + JSON.stringify(update));
            setIsloading(true);
            let saverep = await updateCompanyInfo(update);
            console.log(`reponse of Edit company info :::: ${JSON.stringify(saverep)}`);
            let saverepeMsg = await saverep.json();
            console.log(
                "response of modified data company info  :::" + JSON.stringify(saverepeMsg)
            );
            setTimeout(() => {
                setIsloading(false);
            }, 1000);
            if (saverepeMsg.status && saverepeMsg.status == "success") {
                setallowRequst(true);
                setSuccessMessage(saverepeMsg.message);
            } else {
                if (saverepeMsg.message?.errors) {
                    saverepeMsg.message.errors.forEach((err) => {

                        setError(err.param_name, {
                            type: "server",
                            message: err.message,
                        });
                        const fieldElement = document.querySelector(
                            `input[name="${err.param_name}"]`
                        );
                        if (fieldElement) {
                            fieldElement.focus();
                            fieldElement.scrollIntoView({ behavior: "smooth" });
                        }
                    });
                }
            }
        }

    }

    const section1 = useRef(null);
    const section2 = useRef(null);
    const section3 = useRef(null);
    const section4 = useRef(null);
    const section5 = useRef(null);
    const section6 = useRef(null);

    const containerRef = useRef(null);


    useEffect(() => {
        const timeoutId = setTimeout(() => {
            const scrollspyLinks = document.querySelectorAll(".nav-link");
            const lastLink = scrollspyLinks[scrollspyLinks.length - 1];
            const stickyParent = lastLink.closest(".sticky-top");
            if (stickyParent && lastLink.classList.contains("active")) {
                lastLink.classList.remove("active");
                for (let i = 0; i < scrollspyLinks.length; i++) {
                    const firstLink = scrollspyLinks[i];
                    const parent = firstLink.closest(".sticky-top");
                    if (parent) {
                        firstLink.classList.add("active");
                        break;
                    }
                }
            }
        }, 100);
        return () => clearTimeout(timeoutId);
    }, []);


    useEffect(() => {
        if (containerRef.current) {
            containerRef.current.scrollTop = 0;
        }
    }, []);


    return (
        <React.Fragment>
            <>
                <MainLinks active={6} />
                <Body
                    tablinks={6}
                    sublink={123}
                    content={
                        <>
                            <section className="mb-3">
                                <div className="card card-height">
                                    <div className="card-header px-0">
                                        <h5 className="fw-600">{t("acc_info")}</h5>
                                    </div>
                                    <div className="card-body px-0 w-100">

                                        <MDBTabs className='mb-3'>
                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab1')} active={accountInfo === 'tab1'}>
                                                    Settings
                                                </MDBTabsLink>
                                            </MDBTabsItem>
                                        </MDBTabs>
                                        <MDBTabsContent>
                                            <MDBTabsPane open={accountInfo === 'tab1'}>


                                                <MDBRow>
                                                    <MDBCol
                                                        size="2"
                                                        md="2"
                                                        lg="2"
                                                        sm="12"
                                                        className="col-sm-100 pr-0 leftTabs"
                                                    >
                                                        <MDBScrollspy container={containerRef}>
                                                            <MDBScrollspyLink targetRef={section1}>
                                                                Company Details
                                                            </MDBScrollspyLink>
                                                        </MDBScrollspy>
                                                    </MDBCol>

                                                    <MDBCol
                                                        size="12"
                                                        md="10"
                                                        sm="12"
                                                        pr-0
                                                        className="col-sm-100 pr-0 leftTabContent"
                                                    >
                                                        <div ref={containerRef} className="scrollspy-example mx-0">
                                                            <section ref={section1} id="section-1">
                                                                <div className="general-settings">Company Details</div>

                                                                <div className="w-80">
                                                                    <div className="add-numbermain">
                                                                        <div className="tel-numbers">Company Name</div>
                                                                        <div className="d-flex w-30">
                                                                            <div className="w-100">
                                                                                <div className="phoneselect w-100">
                                                                                    <input maxLength={50} className="form-control" disabled="" {...register("global_settings.company_info.company_name", { required: "Company Name is required" })} />
                                                                                    {errors?.global_settings?.company_info?.company_name && (
                                                                                        <p className="text-danger">{errors?.global_settings?.company_info?.company_name?.message}</p>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="add-numbermain">
                                                                        <div className="tel-numbers">Admin First Name</div>
                                                                        <div className="d-flex w-30">
                                                                            <div className="w-100">
                                                                                <div className="phoneselect w-100">
                                                                                    <input maxLength={30} className="form-control" disabled="" {...register("global_settings.company_info.admin_first_name", { required: "Admin first name is required" })} />
                                                                                    {errors?.global_settings?.company_info?.admin_first_name && (
                                                                                        <p className="text-danger">{errors?.global_settings?.company_info?.admin_first_name?.message}</p>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>


                                                                    <div className="add-numbermain">
                                                                        <div className="tel-numbers">Admin Last Name</div>
                                                                        <div className="d-flex w-30">
                                                                            <div className="w-100">
                                                                                <div className="phoneselect w-100">
                                                                                    <input maxLength={20} className="form-control" disabled="" {...register("global_settings.company_info.admin_last_name", { required: "Admin last name is required" })} />
                                                                                    {errors?.global_settings?.company_info?.admin_last_name && (
                                                                                        <p className="text-danger">{errors?.global_settings?.company_info?.admin_last_name?.message}</p>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    {/* commented below code as part of Jerome Suggested Changes */}
                                                                    {/* <div className="add-numbermain">
                                                        <div className="tel-numbers">Password</div>
                                                        <div className="d-flex w-30">
                                                            <div className="w-100">
                                                                <div className="phoneselect w-100">
                                                                    <input className="form-control" type="password" disabled="" {...register("global_settings.company_info.password")} />
                                                                    {errors?.global_settings?.company_info?.password && (
                                                                        <p className="text-danger">{errors?.global_settings?.company_info?.password?.message}</p>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> */}

                                                                    <div className="add-numbermain">
                                                                        <div className="tel-numbers">Phone Number(s)</div>
                                                                        <div className="d-flex w-30">
                                                                            <div className="w-100">
                                                                                <div className="phoneselect w-100">
                                                                                    <input className="form-control" onKeyPress={(event) => {
                                                                                        if (!/[0-9]/.test(event.key)) {
                                                                                            event.preventDefault();
                                                                                        }
                                                                                    }} disabled=""  {...register("global_settings.company_info.phone_number", {
                                                                                        required: "Phone number is required",
                                                                                        validate: validatePhoneNumber,
                                                                    
                                                                                      })}
                                                                                    />
                                                                                    
                                                                                    {errors?.global_settings?.company_info?.phone_number && (
                                                                                        <p className="text-danger">{errors?.global_settings?.company_info?.phone_number?.message}</p>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="add-numbermain">
                                                                        <div className="tel-numbers">Email</div>
                                                                        <div className="d-flex w-30">
                                                                            <div className="w-100">
                                                                                <div className="phoneselect w-100">
                                                                                    <input className="form-control" type="email" disabled="" {...register("global_settings.company_info.email", {
                                                                                       setValueAs:(v)=>v?.trim(),
                                                                                        required: "Email is required", pattern: {
                                                                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                                                            message: "Invalid email address",
                                                                                        },
                                                                                    })} />
                                                                                    {errors?.global_settings?.company_info?.email && (
                                                                                        <p className="text-danger">{errors?.global_settings?.company_info?.email?.message}</p>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="add-numbermain">
                                                                        <div className="tel-numbers">Timezone</div>
                                                                        <div className="d-flex w-30">
                                                                            <div className="w-100">
                                                                                <div className="">
                                                                                    <MDBSelect
                                                                                        //   style={{ width: "210px" }}
                                                                                        search
                                                                                        className="timeZone"
                                                                                        label={false}
                                                                                        data={timezone}
                                                                                        value={parseInt(watch("global_settings.company_info.time_zone"))}
                                                                                        onChange={(e) => {
                                                                                            if (e && e.value) {
                                                                                                const selectedValue = parseInt(e.value);
                                                                                                setValue("global_settings.company_info.time_zone", selectedValue, {
                                                                                                    shouldDirty: true,
                                                                                                });
                                                                                            }
                                                                                        }}
                                                                                    />

                                                                                    {/* <select name="" id="" {...register("global_settings.company_info.time_zone", { setValueAs: (value) => Number(value), required: "Time Zone is required" })} className="w-100 form-select">
                                                                        {timezone && timezone.map((time) => (
                                                                            <option value={time.tid}>{time.time_zone}</option>
                                                                        ))}
                                                                    </select> */}
                                                                                    {errors?.global_settings?.company_info?.time_zone && (
                                                                                        <p className="text-danger">{errors?.global_settings?.company_info?.time_zone?.message}</p>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="add-numbermain">
                                                                        <div className="tel-numbers">Industry Type</div>
                                                                        <div className="d-flex w-30">
                                                                            <div className="w-100">
                                                                                <div className="phoneselect w-100">
                                                                                    <select name="" id="" className="w-100 form-select" value={watch("global_settings.company_info.industry_type")}
                                                                                        onChange={(e) => setValue("global_settings.company_info.industry_type", e.target.value, { shouldDirty: true })}
                                                                                    >
                                                                                        {industrytypes && industrytypes.map((type) => (
                                                                                            <option value={type}>{type}</option>
                                                                                        ))}
                                                                                    </select>
                                                                                    {errors?.global_settings?.company_info?.industry_type && (
                                                                                        <p className="text-danger">{errors?.global_settings?.company_info?.industry_type?.message}</p>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="add-numbermain">
                                                                        <div className="tel-numbers">Street Address 1</div>
                                                                        <div className="d-flex w-30">
                                                                            <div className="w-100">
                                                                                <div className="phoneselect w-100">
                                                                                    {/* <input className="form-control" type="text" disabled="" {...register("global_settings.company_info.street_address1", { required: "Address is required" })} /> */}
                                                                                    <MDBAutocomplete
                                                                                        data={addressReasults}
                                                                                        // value={addressValue}
                                                                                        value={watch("global_settings.company_info.street_address1")}
                                                                                        displayValue={(address) => address.street_line}
                                                                                        isLoading={isLoading}
                                                                                        // open={isDisplay}
                                                                                        // placeholder='Address 1'
                                                                                        onSearch={handleSearchAddressChange}
                                                                                        onSelect={(e) => {
                                                                                            allowAPI.current = false;
                                                                                            setisDisplay(false);

                                                                                        }}
                                                                                        itemContent={(address) => (
                                                                                            <div onClick={(e) => {
                                                                                                e.preventDefault();
                                                                                                allowAPI.current = false;
                                                                                                handleAddressSelect(address);
                                                                                            }}>
                                                                                                {address.country &&
                                                                                                    <img src={address.country === "USA" ? USA : CANADA} className='me-3' width={25} />
                                                                                                }
                                                                                                {address.street_line || ""}{address.secondary ? ", " + address.secondary : ""}{address.city ? ", " + address.city : ""}{address.state ? ", " + address.state : ""}{address.zipcode ? ", " + address.zipcode : ""}
                                                                                            </div>
                                                                                        )}
                                                                                    />
                                                                                    {errors?.global_settings?.company_info?.street_address1 && (
                                                                                        <p className="text-danger">{errors?.global_settings?.company_info?.street_address1?.message}</p>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="add-numbermain">
                                                                        <div className="tel-numbers">Street Address 2</div>
                                                                        <div className="d-flex w-30">
                                                                            <div className="w-100">
                                                                                <div className="phoneselect w-100">
                                                                                    <input className="form-control" type="text" disabled="" {...register("global_settings.company_info.street_address2")} />
                                                                                </div>
                                                                                {errors?.global_settings?.company_info?.street_address2 && (
                                                                                    <p className="text-danger">{errors?.global_settings?.company_info?.street_address2?.message}</p>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="add-numbermain">
                                                                        <div className="tel-numbers">City/Town</div>
                                                                        <div className="d-flex w-30">
                                                                            <div className="w-100">
                                                                                <div className="phoneselect w-100">
                                                                                    <input className="form-control" type="text" onKeyPress={(event) => {
                                                                                        if (!/^[a-zA-Z ]*$/.test(event.key)) { 
                                                                                            event.preventDefault();
                                                                                        }
                                                                                    }} disabled="" {...register("global_settings.company_info.city", { required: "City is required" })} />
                                                                                    {errors?.global_settings?.company_info?.city && (
                                                                                        <p className="text-danger">{errors?.global_settings?.company_info?.city?.message}</p>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="add-numbermain">
                                                                        <div className="tel-numbers">State</div>
                                                                        <div className="d-flex w-30">
                                                                            <div className="w-100">
                                                                                <div className="phoneselect w-100">
                                                                                    <select name="" id="" className="w-100 form-select" value={watch("global_settings.company_info.state")} onChange={(e) => setValue("global_settings.company_info.state", e.target.value, { shouldDirty: true })}>
                                                                                        {states && states.map((state) => (
                                                                                            <option value={state.statename}>{state.statename}</option>
                                                                                        ))}
                                                                                    </select>
                                                                                    {errors?.global_settings?.company_info?.state && (
                                                                                        <p className="text-danger">{errors?.global_settings?.company_info?.state?.message}</p>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="add-numbermain">
                                                                        <div className="tel-numbers">ZIP Code</div>
                                                                        <div className="d-flex w-30">
                                                                            <div className="w-100">
                                                                                <div className="phoneselect w-100">
                                                                                    <input className="form-control" type="text" {...register("global_settings.company_info.zip_code", { required: "ZIP Code is required" })} />
                                                                                    {errors?.global_settings?.company_info?.zip_code && (
                                                                                        <p className="text-danger">{errors?.global_settings?.company_info?.zip_code?.message}</p>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {/* commented below code as part of Jerome Suggested Changes */}
                                                                    {/* <div className="add-numbermain ">
                                                        <div className="tel-numbers">User Extension Length</div>
                                                        <div className="d-flex w-30">
                                                            <div className="w-100">
                                                                <div className="phoneselect w-100">
                                                                    <input className="form-control" type="text" {...register("global_settings.company_info.user_extension_length", { required: "User Extension Length is required", setValueAs: (value) => Number(value) })} />
                                                                    {errors?.global_settings?.company_info?.user_extension_length && (
                                                                        <p className="text-danger">{errors?.global_settings?.company_info?.user_extension_length?.message}</p>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                                    {isSave && (
                                                                        <SaveChanges
                                                                            onClose={closeSave}
                                                                            isdirtyFields={isSave}
                                                                            onSave={(e) => {
                                                                                e.preventDefault();
                                                                                handleSubmit(onSubmit)();
                                                                            }}
                                                                        />
                                                                    )}

                                                                </div>


                                                            </section>
                                                        </div>
                                                    </MDBCol>
                                                </MDBRow>





                                            </MDBTabsPane>
                                        </MDBTabsContent>
                                    </div>
                                </div>
                            </section>
                            {isloading && (
                                <>
                                    <div className="loadingclass">
                                        <MDBBtn disabled>
                                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                                            Loading...
                                        </MDBBtn>
                                    </div>
                                </>
                            )
                            }
                            {successMessage && (
                                <>
                                    <TopSuccess>
                                        <TopMessage successMessage={successMessage} />
                                    </TopSuccess>
                                </>
                            )}
                        </>
                    }
                />
            </>
        </React.Fragment>
    )
}

export default AccountInfoLanding